import './ModalLayout.scss';

import Modal from './Modal/Modal';
import NavBar from '../ui-components/NavBar/NavBar';
import PropTypes from 'prop-types';
import React from 'react';
import withRouter from '../hocs/withRouter';

class ModalLayoutBase extends React.Component {

  static propTypes = {
    children: PropTypes.element
  };

  constructor() {
    super();
    this.onClose = this.onClose.bind(this);
  }
  
  onClose() {
    const { navigate } = this.props;
    navigate(-1);
  }

  render() {
    const { children } = this.props;

    return (
      <div className='map-layout--root'>
        <NavBar />
        <Modal onClose={this.onClose}>
          <div className='map-layout--components'>{children}</div>
        </Modal>
      </div>
    );
  }
}


export const ModalLayout = withRouter(ModalLayoutBase);

export default ModalLayout
